<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="title">
            {{ getSnippets('Information') }}
          </div>
          <ul class="information-list">
            <li>
              <span class="company">{{ getSnippets('Company') }}</span>
              <span class="address" v-html="getSnippets('Company Address')"></span>
            </li>
            <li>
              <strong>Tel:</strong> <a :href="'tel:' + getSnippets('Company Phone')">{{ getSnippets('Company Phone') }}</a>
            </li>
            <li>
              <strong>Fax:</strong> {{ getSnippets('Company Fax') }}
            </li>
            <li>
              <strong>E-mail:</strong> <a :href="'mailto:' + getSnippets('Company Email')">{{ getSnippets('Company Email') }}</a>
            </li>
            <li>
              <strong>MB:</strong> {{ getSnippets('Company MB') }}
            </li>
            <li>
              <strong>OIB:</strong> {{ getSnippets('Company VAT') }}
            </li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="title">
            {{ getSnippets('Menu') }}
          </div>
          <ul class="navigation-list">
            <li v-for="item in data.navigation.main" :key="item.id">
              <router-link :to="{ path: item.slug }">
                {{ getTranslation(item, 'title') }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="title">
            {{ getSnippets('Quick Links') }}
          </div>
          <ul class="navigation-list">
            <li v-for="item in data.navigation.quick" :key="item.id">
              <router-link :to="{ path: item.slug }">
                {{ getTranslation(item, 'title') }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="title">
            {{ getSnippets('Other') }}
          </div>
          <ul class="navigation-list">
            <li v-for="item in data.navigation.footer" :key="item.id">
              <router-link :to="{ path: item.slug }">
                {{ getTranslation(item, 'title') }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
/* Mixins */
import {Default} from '@mixins/Default';

/* Logic */
export default {
  name: 'Footer',
  mixins: [Default],
  props: [
    'data'
  ]
}
</script>

<style lang="scss" scoped>
@import "@css/core/_variables.scss";
@import "@css/mixins/_breakpoints.scss";
@import "@css/mixins/_functions.scss";

.footer {
  padding: 64px 0;
  background-color: $color-2;

  // Tablet
  @include media-breakpoint-down(lg) {
    padding: 48px 0 32px;
  }

  .title {
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    color: $white;
    border-bottom: 1px solid rgba(255,255,255,0.3);
    margin-bottom: 24px;
    padding-bottom: 24px;

    // Tablet
    @include media-breakpoint-down(lg) {
      font-size: 16px;
      margin-bottom: 16px;
      padding-bottom: 16px;
    }
  }

  .information-list {
    list-style: none;
    margin: 0;
    padding: 0;

    // Tablet
    @include media-breakpoint-down(lg) {
      margin-bottom: 24px;
    }

    li {
      color: $white;
      line-height: 1.6;

      a {
        color: $white;
      }

      .company {
        display: block;
        font-weight: 700;
        margin-bottom: 4px;
      }

      .address {
        display: inline-block;
        margin-bottom: 12px;
      }
    }
  }

  .navigation-list {
    list-style: none;
    margin: 0;
    padding: 0;

    // Tablet
    @include media-breakpoint-down(lg) {
      margin-bottom: 24px;
    }

    li {
      color: $white;
      line-height: 1.6;

      a {
        color: $white;
      }

      .company {
        display: block;
        font-weight: 700;
        margin-bottom: 4px;
      }

      .address {
        display: inline-block;
        margin-bottom: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Footer.vue